// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import Card from './Card';
import Button from './Button';

type Props = {
  showConsentForm: () => void
}

const ConsentForm = ({ showConsentForm }: Props) => {
  const { t } = useTranslation('consentFormLink');
  return (
    <Card noShadow noBorder noPadding className='consent-form'>
      {showConsentForm &&
        <Button
          className='consent-form__link'
          role='button'
          onClick={showConsentForm}
        >
          {t('view_my_consent_form')}
        </Button>}
    </Card>
  );
};

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/shared/ConsentFormLink.js